import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { Global } from '@emotion/core';

import SessionLayout from '@zego/layouts/SessionLayout';
import { disabledColor } from '@zego/theme';

function SecondaryBackground() {
  return (
    <Global
      styles={{
        body: {
          backgroundColor: `${disabledColor(2)} !important`,
        },
      }}
    />
  );
}

function PromotionsLayout({ viewer, ...props }) {
  return (
    <>
      <SecondaryBackground />
      <SessionLayout viewer={viewer} {...props} />
    </>
  );
}

export default createFragmentContainer(PromotionsLayout, {
  viewer: graphql`
    fragment PromotionsLayout_viewer on Viewer {
      ...SessionLayout_viewer
    }
  `,
});
